var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "l-item" }, [
    _c("div", { staticClass: "l-a", attrs: { title: _vm.a_info } }, [
      _c("div", { staticClass: "name" }, [
        _vm._v(" " + _vm._s(_vm.item.a_object.name)),
        _vm.index === 0
          ? _c(
              "span",
              {
                staticClass: "help-class",
                attrs: { title: "点击出现提示" },
                on: {
                  click: function($event) {
                    return _vm.$emit("help-msg", 1)
                  }
                }
              },
              [_vm._v("?")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number.lazy",
            value: _vm.item.a_object.value,
            expression: "item.a_object.value",
            modifiers: { number: true, lazy: true }
          }
        ],
        attrs: {
          type: "text",
          onfocus: "this.select()",
          onkeyup: "this.value=this.value.replace(/[^\\d.]/g,'')"
        },
        domProps: { value: _vm.item.a_object.value },
        on: {
          change: [
            function($event) {
              _vm.$set(_vm.item.a_object, "value", _vm._n($event.target.value))
            },
            function($event) {
              return _vm.$emit("update_data")
            }
          ],
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "l-b", attrs: { title: _vm.b_info } }, [
      _c("div", { staticClass: "name" }, [
        _vm._v(" " + _vm._s(_vm.item.b_object.name))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.item.b_object.value,
            expression: "item.b_object.value",
            modifiers: { lazy: true }
          }
        ],
        attrs: {
          type: "text",
          onfocus: "this.select()",
          onkeyup: "this.value=this.value.replace(/[^\\d.]/g,'')"
        },
        domProps: { value: _vm.item.b_object.value },
        on: {
          change: [
            function($event) {
              return _vm.$set(_vm.item.b_object, "value", $event.target.value)
            },
            function($event) {
              return _vm.$emit("update_data")
            }
          ]
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }